import { DataGrid } from '@tableau/widgets-datagrid';
import _ from 'underscore';

import { IDataConnectionInfo } from '../../../ts/models/IDataConnectionInfo';
import { INamedItemInfo } from '../../../ts/models/resourceInfoParts';
import { FlowInputStep } from '../../../ts/ServerApi/types/FlowInputStep';
import { FlowOutputStep } from '../../../ts/ServerApi/types/FlowOutputStep';

export function makeGetStepNamesForRow(steps: ReadonlyArray<FlowInputStep | FlowOutputStep> | null) {
  return function getStepNamesForRow(row: DataGrid.Row): ReadonlyArray<INamedItemInfo> {
    const connection = row.data as IDataConnectionInfo;
    if (connection && steps) {
      return _.filter(steps, (step) => step.connectionId === connection.id);
    }
    return [];
  };
}
